

export const barneyBio = {
  _id: 'barneyBioId',
  userId: 'barneyUserId',
  email: 'barney@email.com',
  aboutMe: [
    `Legendary`,
    `LEGENDARY`,
    `Legen-DARY`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `True love, but would settle for a threeway with a pair of twins`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Saying "Have you met Ted" to the girl at the bar who Ted is too shy to talk to and then disappearing so that Ted has no choice but to talk to her`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Are married friends lame?`,
    }
  ],
  hobbies: [
    `Marathons`,
    `Friends`,
    `Repressing Trauma`,
    `Legendary Nights`,
    `Scheming`
  ],
  vitalInfo: {
    firstName: `Barney`, 
    age: 36,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 70,
    heightCM: 180,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Rhode Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Investor`,
    employer: `Real Estate`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Short-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const robinBio = {
  _id: 'robinBioId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  aboutMe: [
    `Canadian news reporter in New York, always up for a hockey game`,
    `Warning: will say 'eh' while referencing my pet moose who I found outside Tim Horton's`,
    `Will say whatever obscene thing you want me to say on live tv for $500`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who can keep up`,
    },
    {
      prompt: `My simple pleasures`,
      response: `A beer with friends while watching the game`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite maple syrup brand`,
    }
  ],
  hobbies: [
    `Restaurants/Bars`,
    `Pilates`,
    `Running`,
    `Concerts`,
    `Cocktails`
  ],
  vitalInfo: {
    firstName: `Robin`, 
    age: 27,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 68,
    heightCM: 172,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Saskatoon`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `University of Toronto`,
    profession: `News Anchor`,
    employer: `Channel 5`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const tedBio = {
  _id: 'tedBioId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  aboutMe: [
    `Architect building a life for himself in New York, hoping to share the roof with someone special`,
    `Chronic overthinker looking for someone to decide once and for all whether I should button the top button or not on my blazer`,
    `Old soul and pedantic over-explainer`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `The girl with the yellow umbrella`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Coffee in the morning, misty rain, and beers with friends`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite shade of pastel`,
    }
  ],
  hobbies: [
    `Architecture`,
    `Bars/Restaurants`,
    `Travel`,
    `Coffee`,
    `Video Games`
  ],
  vitalInfo: {
    firstName: `Ted`, 
    age: 29,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 73,
    heightCM: 185,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Ohio`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Haverford`,
    profession: `Architect`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}